/**
 * Utilidades para detectar si la aplicación se está ejecutando como PWA instalada o App Nativa.
 */

export const isAppMode = () => {
  // 1. Detección de Capacitor (Android/iOS Nativo REAL)
  // Solo es Capacitor si el plugin está presente Y la plataforma NO es 'web'
  const isCapacitor = !!(
    window.Capacitor && 
    window.Capacitor.isNativePlatform && 
    window.Capacitor.getPlatform && 
    window.Capacitor.getPlatform() !== 'web'
  );

  // 2. Detección de PWA Standalone (Chrome/Edge/Android)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

  // 3. Detección de iOS Standalone (Safari)
  const isIOSStandalone = !!window.navigator.standalone;

  const result = isCapacitor || isStandalone || isIOSStandalone;
  
  // Log para debugging (solo en desarrollo)
  if (process.env.NODE_ENV === 'development' && result) {
    console.log('[PWA Check]', { 
      isCapacitor, 
      isStandalone, 
      isIOSStandalone, 
      platform: window.Capacitor ? window.Capacitor.getPlatform() : 'none',
      result 
    });
  }

  return result;
};

/**
 * Verifica si la aplicación ya está instalada en el sistema (Chrome/Edge/Android)
 * @returns {Promise<boolean>}
 */
export const checkIsInstalled = async () => {
  // Si ya estamos en modo standalone, es obvio que está instalada
  if (isAppMode()) return true;

  // Intentar usar la API nativa de Chrome
  if ('getInstalledRelatedApps' in window.navigator) {
    try {
      const relatedApps = await window.navigator.getInstalledRelatedApps();
      return relatedApps.length > 0;
    } catch (e) {
      console.warn('Error checking installed apps:', e);
    }
  }

  // Fallback: check localStorage for previous installation success
  return localStorage.getItem('pwa_installed_success') === 'true';
};

export const getDisplayMode = () => {
  if (window.Capacitor) return 'native';
  if (window.matchMedia('(display-mode: standalone)').matches) return 'pwa-standalone';
  return 'browser';
};

/**
 * Verifica si es un dispositivo móvil o tablet
 */
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isSmallScreen = window.innerWidth <= 1024; // Incluye tablets
  return isMobileUA || isSmallScreen;
};

